import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="wFooter" role="contentinfo">
      <div className="wFooter__inner">
        <div className="wFooter__top">
          <div className="wFooter__hero">
            <div className="wFooter__brand">WPARK</div>

            <h2 className="wFooter__headline">
              MAKE THE PHYSICAL WORLD
              <br />
              UNDERSTANDABLE TO AI
            </h2>
          </div>

          <nav className="wFooter__nav" aria-label="Footer navigation">
            <NavLink to="/" end className="wFooter__navLink">
              HOME
            </NavLink>

            <NavLink to="/Team" className="wFooter__navLink">
              TEAM
            </NavLink>

            <NavLink to="/Advisors" className="wFooter__navLink">
              ADVISORS
            </NavLink>
          </nav>
        </div>

        <div className="wFooter__bottom">
          <div className="wFooter__contact">
            <div className="wFooter__label">CONTACT</div>

            <a href="mailto:team@thewpark.com" className="wFooter__email">
              team@thewpark.com
            </a>
          </div>

          <div className="wFooter__copyright">
            © 2026 WPARK LTD. ALL RIGHTS RESERVED.
          </div>

          <div className="wFooter__social">
            <a
              href="https://www.linkedin.com/company/wpark25/"
              target="_blank"
              rel="noreferrer"
              className="wFooter__linkedin"
            >
              LinkedIn ↗
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}